export default {
  data() {
    return {
      active: true
    };
  },
  methods: {
    extractDataThenReturnNewArray(array, tag) {
      // u is conndition like type
      let temp = [];
      for (var i = 0; i < array.length; i++) {
        if (tag == array[i].tag) {
          temp.push(array[i]);
        }
      }
      return temp;
    },
    getListFromSource(source) {
      let k = [];
      if (source == "maintAssurance" || source == "maintStrategy") {
        // k = this.getDetailRelpsLocal;
      }
      return k;
    },
    splitRelpsLocalToStore(u) {
      let temp = {
        ma: [],
        ms: [],
        mp: [],
        ro: []
      };
      // u is list
      if (u !== null) {
        // get individual temp
        temp.ma = this.extractDataThenReturnNewArray(u, "M0");
        temp.ms = this.extractDataThenReturnNewArray(u, "M1");
        temp.mp = this.extractDataThenReturnNewArray(u, "M2");
        temp.ro = this.extractDataThenReturnNewArray(u, "R1");
      }
      // Update Store
      this.$store.dispatch("changeRelpsLocalMA", temp.ma);
      this.$store.dispatch("changeRelpsLocalMS", temp.ms);
      this.$store.dispatch("changeRelpsLocalMP", temp.mp);
    }
  }
};
